import { useEffect, useState } from 'react';
import { Button, Group } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useTranslation } from 'react-i18next';

type DepositsDueDateFilterPropsType = {
  dueDateFrom?: string;
  dueDateTo?: string;
  onApplyDueDateFilter: (payload: {
    dueDateFrom: string | null;
    dueDateTo: string | null;
  }) => void;
};

export const DepositsDueDateFilter: React.FC<
  DepositsDueDateFilterPropsType
> = ({ dueDateFrom, dueDateTo, onApplyDueDateFilter }) => {
  const { t } = useTranslation('financeDeposits');

  const [draftDueDateFrom, setDraftDueDateFrom] = useState<string | null>(
    dueDateFrom ?? null
  );
  const [draftDueDateTo, setDraftDueDateTo] = useState<string | null>(
    dueDateTo ?? null
  );

  useEffect(() => {
    setDraftDueDateFrom(dueDateFrom ?? null);
    setDraftDueDateTo(dueDateTo ?? null);
  }, [dueDateFrom, dueDateTo]);

  const isUnchanged =
    draftDueDateFrom === (dueDateFrom ?? null) &&
    draftDueDateTo === (dueDateTo ?? null);

  const handleApply = () => {
    onApplyDueDateFilter({
      dueDateFrom: draftDueDateFrom,
      dueDateTo: draftDueDateTo,
    });
  };

  return (
    <Group align="flex-end">
      <DatePickerInput
        clearable
        valueFormat="DD.MM.YYYY"
        label={t('DEPOSITS_TABLE.FILTERS.DUE_DATE_LABEL')}
        placeholder={t('DEPOSITS_TABLE.FILTERS.DUE_DATE_FROM_PLACEHOLDER')}
        value={draftDueDateFrom}
        onChange={setDraftDueDateFrom}
        size="xs"
        w={150}
      />
      <DatePickerInput
        clearable
        valueFormat="DD.MM.YYYY"
        placeholder={t('DEPOSITS_TABLE.FILTERS.DUE_DATE_TO_PLACEHOLDER')}
        value={draftDueDateTo}
        onChange={setDraftDueDateTo}
        size="xs"
        w={150}
      />
      <Button onClick={handleApply} size="xs" disabled={isUnchanged}>
        {t('DEPOSITS_TABLE.FILTERS.APPLY')}
      </Button>
    </Group>
  );
};
